import type {
  JobOperator,
} from '../types'

// Constants
import { MODEL } from 'fc-model-sampling-jobs'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: JobOperator = composeOperator({
  model: MODEL,
})

export default operator
